module.exports = __webpack_public_path__ + "img/user.7c0cc90b.png";